import './ManageProfile.scss';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { useFooter } from 'hooks';
import Layout from 'components/Layout/Layout';
import Title from 'components/Title/Title';
import MyProfileForm from 'components/MyProfileForm/MyProfileForm';

const ManageProfile: React.FC = () => {
  const { data: dataFooter } = useFooter();
  const footer = documentToHtmlString(dataFooter?.footer);

  return (
    <Layout copyright={footer}>
      <div className="ManageProfile-page">
        <Title text="My profile" />

        <MyProfileForm />
      </div>
    </Layout>
  );
};

export default ManageProfile;
